// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconArrowRight: React.FC = () => {
    return (
        <svg
            width="18px"
            height="18px"
            viewBox="0 0 18 18"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="currentColor"
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g
                    id="Buttons/Buttons-:-Ghost/Button-:-Ghost-:-Large"
                    transform="translate(-142.000000, -15.000000)"
                    fill="currentColor"
                >
                    <path d="M160,24 C160,28.9692573 155.953057,33 150.958863,33 C146.382705,33 142.595923,29.6111658 142,25.2174127 L150.491909,25.2174127 L150.491909,27.4530251 C150.491909,27.7429907 150.683138,28.0307427 150.976652,28.1591244 C151.27239,28.3162814 151.614824,28.2587309 151.850525,28.101574 L155.619518,24.6197737 C155.964175,24.3032464 155.964175,23.7609444 155.619518,23.4422036 L151.850525,19.9604033 C151.614824,19.7434825 151.27239,19.6859321 150.976652,19.8143138 C150.683138,19.940482 150.491909,20.2304476 150.491909,20.5491884 L150.491909,22.7538121 L142.004447,22.7538121 C142.613712,18.3711264 146.3916,15 150.958863,15 C155.953057,15 160,19.0285293 160,24"></path>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(IconArrowRight);
